import { render } from "./AliceLoader.vue?vue&type=template&id=0ff24454&scoped=true"
import script from "./AliceLoader.vue?vue&type=script&lang=js"
export * from "./AliceLoader.vue?vue&type=script&lang=js"

import "./AliceLoader.vue?vue&type=style&index=0&id=0ff24454&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff24454"]])

export default __exports__